<template>
  <div
    class="wizzard-step-financials"
    :class="{ 'withoutCommitment': hideCommitment }"
  >
    <UIList
      :columns
      :items
      unremovable
    >
      <template #account="{ item }">
        <UIAssetName
          :name="entityLabel(item)"
          class="line-clamp-2"
        />
      </template>
      <template #date="{ item }">
        <component
          :is="item.transaction.getFormDate()"
          :instance="item.transaction"
          :size
        />
      </template>
      <template #amount="{ item }">
        <component
          :is="item.transaction.getFormAmount2()"
          :instance="item.transaction"
          :size
          hide-sign
          trail-currency
        />
      </template>
      <template #description="{ item }">
        <component
          :is="item.transaction.getFormDescription()"
          :instance="item.transaction"
          :size
          placeholder="Optional"
        />
      </template>
    </UIList>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef, inject } from 'vue'

import { WizardEntity } from '../utils/types'
import { InputSize } from '@types'

import { MULTI_ENTITY_CONTEXT } from '../utils/const'

import { getEntityAccountName } from '../utils/helpers'

import { useAssetsBunchStore } from '@/store/assets/bunch'
import { UIAssetName, UIList } from '@ui/core'

defineOptions({ inheritAttrs: false })

const assetsBunchStore = useAssetsBunchStore()

const size = inject<InputSize>('size')
const multi = inject(MULTI_ENTITY_CONTEXT)
const dateLabel = inject<string>('assetDateLabel', 'Date')
const amountLabel = inject<string>('amountLabel', 'Amount')
const hideCommitment = inject<ComputedRef<boolean> | undefined>(
  'hideCommitment',
  undefined,
)

const columns = computed(() => [
  {
    name: 'account',
    caption: 'Investor',
  },
  {
    name: 'date',
    caption: dateLabel,
  },
  ...(hideCommitment?.value ? [] : [{
    name: 'amount',
    caption: amountLabel,
  }]),
  {
    name: 'description',
    caption: 'Description',
  },
])

const items = computed(() => multi?.entities?.value ?? [])

const entityLabel = (entity: WizardEntity) =>
  getEntityAccountName(entity, id => assetsBunchStore.getElementById(id))
</script>

<style>
.wizzard-step-financials {
  .ui-input-text__input--trailing {
    @apply pr-5!;
  }
  .ui-list {
    @apply grid-cols-[1fr_135px_150px_1fr];
    @apply md:grid-cols-[1fr_115px_130px_1fr];
  }

  &.withoutCommitment {
    .ui-list {
      @apply grid-cols-[1fr_130px_1fr];
      @apply md:grid-cols-[1fr_115px_1fr];
    }
  }
}
</style>
